import { Icon } from "@app/icons";

/** A key figure in a ``.kpis`` row: its label, the value, an optional note under it; with ``onClick`` the tile opens
 *  what it counts (a chevron says so). */
export function Kpi(props: { label: string; value: string; sub?: string; className?: string; onClick?: () => void }) {
  const body = (
    <>
      <span className="sm mu hstack" style={{ justifyContent: "space-between" }}>
        {props.label}
        {props.onClick && <Icon name="chevronRight" size={12} />}
      </span>
      <b className={props.className}>{props.value}</b>
      {props.sub && <span className="sm mu">{props.sub}</span>}
    </>
  );
  return props.onClick ? (
    <button type="button" className="kpi kpi-link" onClick={props.onClick}>
      {body}
    </button>
  ) : (
    <div className="kpi">{body}</div>
  );
}
